module.exports = __webpack_public_path__ + "img/image5.bc343f07.png";